import { render, staticRenderFns } from "./TextEllipsis.vue?vue&type=template&id=40ab5dbb&"
import script from "./TextEllipsis.vue?vue&type=script&lang=js&"
export * from "./TextEllipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports